import { render, staticRenderFns } from "./IcContent.vue?vue&type=template&id=54363874&scoped=true"
import script from "./IcContent.vue?vue&type=script&lang=js"
export * from "./IcContent.vue?vue&type=script&lang=js"
import style0 from "./IcContent.vue?vue&type=style&index=0&id=54363874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54363874",
  null
  
)

export default component.exports